import { render, staticRenderFns } from "./DeletedTodoView.vue?vue&type=template&id=05a49709"
import script from "./DeletedTodoView.vue?vue&type=script&lang=js"
export * from "./DeletedTodoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports